// extracted by mini-css-extract-plugin
export default {"white":"white__PbjbV"};